import { FileApi } from '@/apis';
import RootStore from '.';
import BaseStore from './BaseStore';
import { flow, makeObservable, observable } from 'mobx';
import { ResponseData } from '@/types/http';
import { TableState } from '@tanstack/react-table';
import { BodyPostNewFile, File, getCustomerDetailResponse, GetListFileParams } from '@/types/files';

export default class FileStore extends BaseStore {
    api: FileApi;
    listFiles: File[] = [];

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            getCustomerFolderId: flow.bound,
            postNewFile: flow.bound,
            getListFiles: flow.bound,
            listFiles: observable,
            deleteFileById: flow.bound,
            checkFileExist: flow.bound
        });
        this.api = new FileApi();
    }

    *getCustomerFolderId(customerId) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getFolderIDCustomer, customerId, { hideLoading: true });
            if (res.ok) {
                const data: getCustomerDetailResponse = {
                    id: res.data.id,
                    folder_url_id: res.data.folder_url_id,
                    customer_id: res.data.customer_id,
                    company_id: res.data.company_id,
                    status: res.data.status,
                    delete_flag: res.data.delete_flag
                };
                return data;
            }
        } catch (error) {
            return null;
        }
    }

    *postNewFile(payload: BodyPostNewFile) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(
                this.api,
                this.api.postNewFileUploaded,
                payload,
                { hideLoading: true }
            );
            if (res.ok) {
                return true;
            }
        } catch (error) {
            return false;
        }
    }

    *getListFiles(searchParams?: GetListFileParams, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getListFiles,
                payload
            );
            if (res?.ok) {
                this.listFiles = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecord = res.data.paginate.totalRecord;
                return true;
            }
            return false;
        } catch (error) {
            return undefined;
        }
    }

    *deleteFileById(id: string) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(
                this.api,
                this.api.deleteFilesById,
                id
            );
            this.rootStore.apiStore.isLoading = false;
            return res.ok || false;
        } catch (error) {
            return false;
        }
    }

    *checkFileExist(names: any) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(
                this.api,
                this.api.checkFileExist,
                names
            );
            if (res.ok && res.data && res.data.length > 0) {
                return res.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    }

    clean(): void {
        super.clean();
    }
}
